// @flow
/** @jsx h */
import { Component, h } from 'preact'

import styles from './Background.css'

type BackgroundProps = {
  chapters: any,
  chapterIndex: number
}

export class Background extends Component<BackgroundProps> {
  mapElement: HTMLDivElement
  map: any

  componentDidMount () {
    const Map = require('./Map').default
    const mapboxChapters = this.props.chapters.map(chapter => chapter.mapbox)
    this.map = new Map(this.mapElement, mapboxChapters)
  }

  componentWillReceiveProps (nextProps: BackgroundProps) {
    if (Number.isInteger(nextProps.chapterIndex) && nextProps.chapterIndex >= 0) {
      this.map.setActiveChapter(nextProps.chapterIndex)
    }
  }

  render () {
    return (
      <div className={styles.background}>
        <div ref={elm => (this.mapElement = elm)} className={styles.map} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Background.js